import React, { Suspense } from 'react';
import './App.css';
import './assets/styles/global.scss';
import { Routes, Route } from 'react-router-dom';
import AppShell from './layouts/AppShell';
import ProtectedRoute from './components/ProtectedRoute';
import CreatorRoute from './components/CreatorRoute';
import IntroPage from './pages/IntroPage';
import SignInPage from './pages/SignInPage';

// Lazy-load all pages to split the bundle per route
const LobbyPage = React.lazy(() => import('./pages/LobbyPage'));
const PlayerPage = React.lazy(() => import('./pages/PlayerPage'));
const SearchPage = React.lazy(() => import('./pages/SearchPage'));
const UploadPage = React.lazy(() => import('./pages/UploadPage'));
const ProfilePage = React.lazy(() => import('./pages/ProfilePage'));
const DashboardPage = React.lazy(() => import('./pages/DashboardPage'));
const NotificationsPage = React.lazy(() => import('./pages/NotificationsPage'));
const SettingsPage = React.lazy(() => import('./pages/SettingsPage'));
const VaultPage = React.lazy(() => import('./pages/VaultPage'));

function App() {
  return (
    <Suspense fallback={<div className="app-loading" />}>
      <Routes>
        {/* Public: intro + sign-in flow */}
        <Route path="/" element={<IntroPage />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/signup" element={<SignInPage mode="signup" />} />

        {/* Protected routes wrapped in AppShell */}
        <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
          <Route path="/lobby" element={<LobbyPage />} />
          <Route path="/player/:contentId" element={<PlayerPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/upload" element={<CreatorRoute><UploadPage /></CreatorRoute>} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile/:userId" element={<ProfilePage />} />
          <Route path="/dashboard" element={<CreatorRoute><DashboardPage /></CreatorRoute>} />
          <Route path="/vault" element={<VaultPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
